const faqs = [
  {
    question: 'Kann ich das Auto vorher prüfen lassen?',
    answer:
      'Ja, natürlich – das ist gar kein Problem. Wenn Sie möchten, können Sie das Auto gerne bei Ihrer Werkstatt oder beim TÜV/DEKRA überprüfen lassen. Mir ist wichtig, dass Sie ein gutes Gefühl beim Kauf haben.',
  },
  {
    question: 'Gibt es einen Kaufvertrag?',
    answer:
      'Ja, Sie bekommen selbstverständlich einen schriftlichen Vertrag. Ich arbeite mit einer einfachen, klaren Vorlage, in der alle wichtigen Punkte drinstehen. So haben wir beide etwas in der Hand.',
  },
  {
    question: 'Wie kann ich ein Auto reservieren?',
    answer:
      'Am besten einfach kurz melden – per WhatsApp oder Anruf. Gegen einen kleinen Reservierungsbetrag kann ich das Fahrzeug für Sie verbindlich zurückhalten. So haben Sie genug Zeit, alles in Ruhe zu prüfen und zu entscheiden.',
  },
];
export default faqs;